import { MenuItem } from "@mui/material";
import React from "react";
import styles from "../MenuItem.module.css";
import { environmentSwitch, translate } from "../../../../common/providers";

const MenuItemRelog = ({ company, menuItem, onHotRelog = null }) => {
	const isCompanySelected = menuItem.id === company.id;
	const handleHotRelog = () => {
		onHotRelog(menuItem);
	};
	const currentURL = window.location.href;
	const endsWithAdmin = currentURL.endsWith("/admin");
	const isInAdmin = window.location.pathname === "/licence-management";
	return (
		<MenuItem
			className={`${styles.menuItem} ${isCompanySelected && styles["menuItem--selected"]}`}
			disabled={endsWithAdmin && menuItem.role !== "ADMIN"}
			disableRipple={isCompanySelected}
			translate="no"
			onClick={isCompanySelected ? null : handleHotRelog}
		>
			{environmentSwitch({
				main: menuItem.name || menuItem.companyName,
				veolia: translate(
					(isInAdmin && "navigation:common.licence-management.quit") ||
						"navigation:common.licence-management.access"
				),
			})}
		</MenuItem>
	);
};
export default MenuItemRelog;
